import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { toast } from 'react-toastify';
import localOriginCharges from '../../../Services/localOriginCharges'
import locationServices from '../../../Services/locationServices'
import Loader from '../../../Components/Loader'

export const AddSeaConsolidationOriginCharge = () => {

    const [countryList, setCountryList] = useState([])
    const [originCountryValue, setCountryValue] = useState('')
    const [loader, setLoader] = useState(true)

    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            country: '',
            bl_fee: '',
            handling_in_out: '',
            min_handling_in_out: '',
            weightment_charges: '',
            customs_docs: '',
            transport_s2d_to_seaport: '',
        },
        validationSchema: Yup.object({
            country: Yup.string().required('Required'),
            handling_in_out: Yup.string().required('Required'),
            min_handling_in_out: Yup.string().required('Required'),
            weightment_charges: Yup.string().required('Required'),
            customs_docs: Yup.string().required('Required'),
            transport_s2d_to_seaport: Yup.string().required('Required'),
            bl_fee: Yup.string().required('Required'),
        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                country_id:values.country
            }
            delete values.country
            localOriginCharges.addLocalOriginConsolidationChargeSea(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/sea-consolidation-origin-charge-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    useEffect(() => {
        getCountryList()
        // eslint-disable-next-line
    }, [])

    const getCountryList = () => {
        let param = {
            limit: 250,
            page: 1,
          };
        locationServices.getCountry(param).then(res => {
            if (res.status) {
                let arry = []
                // eslint-disable-next-line
                res.data.map(list => {
                    arry.push({ value: list._id, label: list.country_name, data: list })
                })

                let activeCountry = arry.filter(item => item.data.country_currency === 'AED')
                if (activeCountry.length) {
                    onSelectCountry(activeCountry[0])
                }
                setLoader(false)
                setCountryList(arry)
            } else {
                toast.error(res.message)
            }
        })
    }

    const onSelectCountry = (e) => {

        setCountryValue(e)
        formik.setValues({ ...formik.values, country: e.value })

    }

    return (
        <div className="row d-flex justify-content-center">
            <div className="col-lg-8">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label" > Country </label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.country ? !formik.errors.country ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}
                                            value={originCountryValue}
                                            onChange={(e) => onSelectCountry(e)}
                                            options={countryList}
                                            isDisabled
                                           
                                        />
                                        {formik.touched.country && formik.errors.country ? (
                                            <div className="text-danger">{formik.errors.country}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">BL Fee (Aed)</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.bl_fee ? !formik.errors.bl_fee ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('bl_fee')}
                                            placeholder="Enter BL Fee"
                                        />
                                        {formik.touched.bl_fee && formik.errors.bl_fee ? (
                                            <div className="text-danger">{formik.errors.bl_fee}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Customs Docs (Aed)</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.customs_docs ? !formik.errors.customs_docs ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('customs_docs')}
                                            placeholder="customs docs"
                                        />
                                        {formik.touched.customs_docs && formik.errors.customs_docs ? (
                                            <div className="text-danger">{formik.errors.customs_docs}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Weightment Charges (Aed)</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.weightment_charges ? !formik.errors.weightment_charges ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('weightment_charges')}
                                            placeholder="Weightment Charges"
                                        />
                                        {formik.touched.weightment_charges && formik.errors.weightment_charges ? (
                                            <div className="text-danger">{formik.errors.weightment_charges}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Transport ( S2D to Seaport) in Aed</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.transport_s2d_to_seaport ? !formik.errors.transport_s2d_to_seaport ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('transport_s2d_to_seaport')}
                                            placeholder="transport ( S2D to Seaport)"
                                        />
                                        {formik.touched.transport_s2d_to_seaport && formik.errors.transport_s2d_to_seaport ? (
                                            <div className="text-danger">{formik.errors.transport_s2d_to_seaport}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Handling In/Out Per cbm</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.handling_in_out ? !formik.errors.handling_in_out ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('handling_in_out')}
                                            placeholder="handling In/Out"
                                        />
                                        {formik.touched.handling_in_out && formik.errors.handling_in_out ? (
                                            <div className="text-danger">{formik.errors.handling_in_out}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Minimum Handling In/Out (Aed)</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.min_handling_in_out ? !formik.errors.min_handling_in_out ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('min_handling_in_out')}
                                            placeholder="min handling In/Out"
                                        />
                                        {formik.touched.min_handling_in_out && formik.errors.min_handling_in_out? (
                                            <div className="text-danger">{formik.errors.min_handling_in_out}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
